import * as m from 'app/api/redux-jigsaw/jigsaw-methods';
import { createJigsawReaderAction } from 'app/api/redux-jigsaw/jigsaw-action';
import { isPBK } from 'app/api/redux-jigsaw/jigsaw-selectors';

export const getBookmarks = createJigsawReaderAction(m.GET_BOOKMARKS);
export const deleteBookmark = createJigsawReaderAction(m.DELETE_BOOKMARK);
export const setBookmark = createJigsawReaderAction(m.SET_BOOKMARK);
export const navToBookmark = createJigsawReaderAction(m.GO_TO_BOOKMARK);

export function setBookmarkForThumb(thumb) {
  return function(dispatch, getState) {
    if (isPBK(getState())) {
      dispatch(
        setBookmark({
          pbk_label: thumb.label,
          pbk_page: thumb.cfiref.substring(1),
        })
      );
    } else {
      dispatch(setBookmark({ epub_cfi: thumb.cfiref }));
    }
  };
}
